<template>
	<!-- 安全统计 -->
	<div class="animate__animated animate__fadeIn" id="myChart" style="width: 80%;height: 700px;margin: auto;margin-top:2%;"></div>
</template>
<script>
var that;
import echarts from 'echarts';
import request from '@/utils/request';
export default {
	name: 'index',
	data() {
		return {
			legendData: [],
			examData: [],
			passData: []
		};
	},
	mounted() {
		this.fnGetMapData();
		window.addEventListener('resize', this.chartResize);
	},
	methods: {
		chartResize() {
			this.myChart.resize();
		},
		// 获取今日考勤数据
		fnGetMapData() {
			request({
				url: 'exam/count',
				method: 'GET'
			})
				.then(res => {
					if (res.data) {
						let _data = res.data;
						let _legend = [];
						let _exam = [];
						let _pass = [];
						for (let i in _data) {
							let _examVal = _data[i]['total']==0?0:Math.ceil(parseFloat(_data[i]['exam'] / _data[i]['total']).toFixed(2) * 100);
							let _passVal = _data[i]['total']==0?0:Math.ceil(parseFloat(_data[i]['pass'] /  _data[i]['total']).toFixed(2) * 100);
							_legend.push(i);
							_exam.push(_examVal);
							_pass.push(_passVal);
						}
						this.legendData = _legend;
						this.examData = _exam;
						this.passData = _pass;
						this.$nextTick(() => {
							this.drawLine();
						});
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 初始化统计图
		drawLine() {
			var that = this;
			// 基于准备好的dom，初始化echarts实例
			this.myChart = this.$echarts.init(document.getElementById('myChart'));
			// 绘制图表
			this.myChart.setOption({
				color: [
					{
						type: 'linear',
						x: 0,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [
							{
								offset: 0,
								color: '#5fe3ff' // 0% 处的颜色
							},
							{
								offset: 1,
								color: '#0054b7' // 100% 处的颜色
							}
						],
						globalCoord: false // 缺省为 false
					},
					{
						type: 'linear',
						x: 0,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [
							{
								offset: 0,
								color: '#94f36e' // 0% 处的颜色
							},
							{
								offset: 1,
								color: '#2ef70c' // 100% 处的颜色
							}
						],
						globalCoord: false // 缺省为 false
					},
				],
				title: {
					text: '统计班组考试率和合格率(%)',
					textStyle:{
						width: '100%',
						color: '#fff'
					}
				},
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: ['考试率', '合格率'],
					textStyle:{//图例文字的样式
						color:'#fff',
					}
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						data: this.legendData,
						axisLine: {
							lineStyle: {
								type: 'solid',
								color: '#fff',
								width: '2'
							}
						},
						axisLabel: {
							textStyle: {
								color: '#fff'
							},
							formatter: function(value,index){
								return value + '(%)'
							}
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						axisLine: {
							lineStyle: {
								type: 'solid',
								color: '#fff',
								width: '2'
							}
						},
						axisLabel: {
							textStyle: {
								color: '#fff'
							},
							formatter: function(value,index){
								return value + '(%)'
							}
						}
					}
				],
				series: [
					{
						name: '考试率',
						type: 'bar',
						barWidth: '10%',
						data: this.examData,
						label:{
							normal:{
								show: true,
								formatter: '{c}%',
							},
						}
					},
					{
						name: '合格率',
						type: 'bar',
						barWidth: '10%',
						data: this.passData,
						label:{
							normal:{
								show: true,
								formatter: '{c}%',
							},
						}
					}
				]
			});
		}
	}
};
</script>

<style>
#myChart >>> div {
	margin: 30px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/TotalExam/totalExamDefault/index.vue